<template>
  <div class="nav">
    <div class="m_top">
      <div class="wrap">
        <div class="logo">
          <img :src="logoUrl" style="width:400px;height: 35px;border: 0px;" />
        </div>
        <ul class="m_menu">
          <!--<li v-show="!hideMenu">
            <span :class="currentIndex == 0 ? 'on':''">
              <a hidefocus="true" href="index.html" class="active">
                <em>{{language.exhibition}}</em>
              </a>
            </span>
          </li>

          <li v-show="!hideMenu">
            <span :class="currentIndex == 1 ? 'on':''" @click="handleToken">
              <a hidefocus="true" href="#" class="active">
                <em>{{language.userInfo}}</em>
              </a>
            </span>
          </li>
          <li v-show="!hideMenu">
            <span :class="currentIndex == 2 ? 'on':''">
              <a>
                <el-popover
                  :offset="-20"
                  placement="bottom-start"
                  trigger="click"
                  :visible-arrow="false"
                >
                  <img
                    src="../../assets/wx_code.png"
                    style="width: 130px;height: 130px;padding: 20px;"
                  />
                  <div slot="reference" style="font-size: 16px">{{language.applet}}</div>
                </el-popover>
              </a>
            </span>
          </li>

          <li v-show="!hideMenu" v-if="token == null || token == undefined">
            <span :class="currentIndex == 3 ? 'on':''">
              <a hidefocus="true" href="login.html" class="active">
                <em>{{language.login}}</em>
              </a>
            </span>
          </li>

          <li v-show="!hideMenu" v-if="token != null">
            <span :class="currentIndex == 3 ? 'on' : ''">
              <a>
                <el-popover
                  placement="bottom-start"
                  width="120"
                  :offset="-20"
                  trigger="click"
                  :visible-arrow="false"
                >
                  <a hidefocus="true" @click="handleLogout" class="active">
                    <el-button type="text" icon="el-icon-switch-button">{{language.logout}}</el-button>
                  </a>
                  <div slot="reference" style="font-size: 16px">
                    {{userInfo.true_name}}
                    <i class="el-icon-arrow-down el-icon&#45;&#45;right" style="margin-left: 10px"></i>
                  </div>
                </el-popover>
              </a>
            </span>
          </li>

          <li v-show="!hideMenu" v-if="token == null">
            <span :class="currentIndex == 4 ? 'on':''">
              <a hidefocus="true" href="register.html" class="active">
                <em>{{language.register}}</em>
              </a>
            </span>
          </li>

          <li>
            <span @click="handledSwitchLanguage">
              <a class="active">
                <em>{{language.english}}</em>
              </a>
            </span>
          </li>
          <li v-if="lan2=='ch'">
            <span :class="currentIndex == 6 ? 'on':''">
              <a hidefocus="true" href="usages.html" class="active">
                <em>{{language.HTC}}</em>
              </a>
            </span>
          </li>
          <li v-else>
            <span :class="currentIndex == 6 ? 'on':''">
              <a hidefocus="true" href="usagesen.html" class="active">
                <em>{{language.HTC}}</em>
              </a>
            </span>
          </li>-->

          <!--<li v-show="!hideMenu">
            <span :class="currentIndex == 7 ? 'on':''">
              <a hidefocus="true" href="performs.html" class="active">
                <em>{{language.perform}}</em>
              </a>
            </span>
          </li>-->
          <!--<li>
            <span :class="currentIndex == 7 ? 'on':''">
              <a hidefocus="true" href="beian.html?exhibition_id=2" class="active">
                <em>{{language.HTC}}</em>
              </a>
            </span>
          </li>-->
          
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Cook from "../../common/cookie";
import { language } from "../../language/get";
import store from "../../store";
import { mapGetters } from "vuex";

export default {
  props: {
    currentIndex: {
      type: Number,
      default: 0
    },
    hideMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lan2: 'ch',
      language: language(),
      logoUrl: require('@/assets/logo.png')
    };
  },
  mounted() {
    let lan = Cook.get("lang");
    if (lan == "ch") {
    } else {
      this.logoUrl = require('@/assets/logo_en.png');
    }
    this.lan2 =lan;
    // console.log(this.lan2);
  },
  methods: {
    handleToken() {
      if (
        this.token == undefined ||
        this.token == null ||
        Object.keys(this.userInfo).length == 0
      ) {
        return (window.location.href = "login.html");
      }
      return (window.location.href = "user.html");
    },
    handledSwitchLanguage() {
      let lan = Cook.get("lang");
      let page ='';
      if (lan == null || lan == undefined) {
        Cook.set("lang", "ch", 7);
      }
      if (lan == "ch") {
        Cook.del("lang");
        Cook.set("lang", "en", 7);   
        page ='usagesen.html';     
      } else {
        Cook.del("lang");
        Cook.set("lang", "ch", 7);
        page ='usages.html';
      }      
      // location.reload();
      
      let curUrl=window.location.href;
      if(curUrl.indexOf('usages') != -1){
        location.href = page;
        return;
      }else{
        location.reload();
      }
      
    },
    async handleLogout() {
      store.dispatch("Logout", { token: this.token }).then(res => {
        if (res.type == "1") {
          this.$message.success({
            message: this.language.exitSuccess,
            offset: 120,
            duration: 5000
          });
        }
        window.location = "index.html";
      });
    }
  },
  computed: {
    ...mapGetters(["userInfo", "token"])
  }
};
</script>
<style>
.el-popover {
  min-width: 120px !important;
  padding: 0 !important;
  border: none !important;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
}
</style>
<style scoped>
.nav {
  width: 100%;
  height: 81px;
  background-color: #0f408a;
  min-width: 1200px;
  position: relative;
  left: 0;
  top: 0;
  z-index: 900;
}

.m_top {
  position: relative;
  z-index: 900;
  height: 80px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  background: #0f408a;
}

.m_top .wrap {
  width: 1200px;
  margin: auto;
}

.m_top .logo {
  float: left;
  height: 80px;
  font-size: 21px;
  line-height: 80px;
  color: #ffffff;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.m_top .logo span {
  font-size: 16px;
}

.wrap .logo a {
  float: left;
  width: 157px;
  height: 100%;
  color: #ffffff;
  padding-right: 20px;
  text-indent: -9999px;
}

.m_menu {
  height: 80px;
  float: right;
  margin-right:30px;
}
.el-dropdown-link:focus {
  outline: 0 !important;
}
.m_menu li {
  position: relative;
  background-position: right -300px;
  float: left;
  height: 80px;
  font-size: 16px;
}

.m_menu li span {
  background: none;
  float: left;
  height: 80px;
  line-height: 80px;
  font-size: 16px;
  color: #fff;
  text-align: center;
}

.m_menu li a {
  /*padding: 0 20px;*/
 padding:0 15px;
  line-height: 70px;
  color: #fff;
  float: left;
  height: 70px;
  font-size: 16px;
  cursor: pointer;
}

.m_menu li span:hover,
.m_menu li span.on {
  color: #fff;
  background-color: #092652;
  border-bottom: 2px solid #f4a100;
}
.m_menu li span a:hover {
  color: #fff;
}

.m_menu li a em {
  float: left;
  height: 80px;
  line-height: 80px;
  font-size: 16px;
  font-style: normal;
  text-align: left;
}

.m_menu li span.on a.active {
  color: #ffffff;
}
</style>